<template>
  <div class="container">
    <div class="head-btns">
      <el-button
        class="mwow-button-filled primary"
        @click="handleExport"
        v-debounce="1000"
        >导出</el-button
      >
    </div>
    <common-search-form-wrapper :hiddenExpand="true" :reset="handleReset">
      <el-form
        size="mini"
        :model="searchInfo"
        label-width="66px"
        class="search-form"
      >
        <el-row>
          <el-col :span="8">
            <el-form-item label="学员搜索:" prop="key_word">
              <el-input
                v-model="searchInfo.key_word"
                placeholder="学员姓名/手机号"
                maxlength="99"
                prefix-icon="el-icon-search"
                @change="handleSearch"
                clearable
              >
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="积分类型:" prop="source">
              <el-select
                v-model="searchInfo.source"
                placeholder="请选择"
                @change="handleSearch"
                clearable
              >
                <el-option
                  v-for="item in sourceList"
                  :key="item.key"
                  :label="item.value"
                  :value="item.key"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="状态:" prop="type">
              <el-select
                v-model="searchInfo.type"
                placeholder="请选择"
                @change="handleSearch"
                multiple
              >
                <el-option label="增加" :value="2"></el-option>
                <el-option label="扣除" :value="1"></el-option>
                <el-option label="冻结" :value="3"></el-option>
                <el-option label="解冻" :value="4"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="创建时间:" prop="date">
              <!-- <el-date-picker
                v-model="searchInfo.date"
                type="daterange"
                range-separator="至"
                start-placeholder="开始时间"
                end-placeholder="结束时间"
                value-format="yyyy-MM-dd"
                @change="handleSearch"
                :picker-options="effectiveDate"
              >
              </el-date-picker> -->
              <common-date-range-selector
                v-model="searchInfo.date"
                range-separator="至"
                start-placeholder="开始时间"
                end-placeholder="结束时间"
                value-format="yyyy-MM-dd"
                @change="handleSearch"
                :picker-options="effectiveDate"
              >
              </common-date-range-selector>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </common-search-form-wrapper>
    <el-table
      size="mini"
      v-horizontal-scroll
      :data="tableData"
      stripe
      style="width: 100%"
      tooltip-effect="dark"
    >
      <el-table-column label="学员姓名">
        <template slot-scope="scope">
          <div v-if="scope.row.student">
            {{ scope.row.student.name || "-"
            }}<span
              v-if="scope.row.student.is_del === 1"
              class="mwow-tag del-filled large"
              >已删除</span
            >
          </div>
          <div v-else>-</div>
        </template>
      </el-table-column>
      <el-table-column label="手机号">
        <template slot-scope="scope">
          {{ "+" + scope.row.student.area_code }}
          {{ scope.row.student ? scope.row.student.mobile : "-" }}
        </template>
      </el-table-column>
      <el-table-column label="积分类型" prop="source">
        <template slot-scope="scope">{{
          sourceObject[scope.row.source]
        }}</template>
      </el-table-column>
      <el-table-column label="变动积分" prop="integral">
        <template slot-scope="scope">
          <span v-if="scope.row.type === 1" style="color: #f56c6c"
            >-{{ scope.row.integral }}</span
          >
          <span v-else-if="scope.row.type === 2" style="color: #07d1aa"
            >+{{ scope.row.integral }}</span
          >
          <span v-else style="color: #409eff">{{ scope.row.integral }}</span>
        </template>
      </el-table-column>
      <!-- 该字段由后端记录，前端隐藏 -->
      <!-- <el-table-column label="现有积分" prop="usable">
        <template slot-scope="scope">{{ scope.row.usable }}</template>
      </el-table-column> -->
      <el-table-column label="状态" prop="type">
        <template slot-scope="scope">
          <span v-if="scope.row.type === 1" style="color: #f56c6c">{{
            typeObject[scope.row.type]
          }}</span>
          <span v-else-if="scope.row.type === 2" style="color: #07d1aa">{{
            typeObject[scope.row.type]
          }}</span>
          <span v-else style="color: #409eff">{{
            typeObject[scope.row.type]
          }}</span>
        </template>
      </el-table-column>
      <el-table-column label="操作人员">
        <template slot-scope="scope">{{
          scope.row.staff ? scope.row.staff.name : "-"
        }}</template>
      </el-table-column>
      <el-table-column label="备注说明" prop="remark">
        <template slot-scope="scope">{{ scope.row.remark || "-" }}</template>
      </el-table-column>
      <el-table-column label="创建时间" prop="create_time" width="140">
        <template slot-scope="scope">{{ scope.row.create_time }}</template>
      </el-table-column>
    </el-table>
    <el-pagination
      :current-page="page"
      :page-size="pageSize"
      :page-sizes="pageSizeArray"
      :style="{ float: 'right', padding: '20px' }"
      :total="total"
      @current-change="handlePagerChange"
      @size-change="handlePagerSizeChange"
      layout="total, sizes, prev, pager, next, jumper"
    ></el-pagination>
  </div>
</template>
<script>
import {
  getIntegralLogSourceApi,
  getIntegralLogListApi,
  exportIntegralLogApi,
} from "@/api/integral";
import { exportLoop } from "@/utils/export";
import { dateFormat } from "@/utils/timeFormat";
import commonDateRangeSelector from "@/components/commonDateRangeSelector.vue";
import CommonSearchFormWrapper from "@/components/commonSearchFormWrapper.vue";

export default {
  props: ["visible"],
  components: {
    commonDateRangeSelector,
    CommonSearchFormWrapper,
  },
  data() {
    return {
      searchInfo: {
        key_word: "",
        type: [],
        source: "",
        date: [],
      },
      sourceList: [],
      sourceObject: {},
      tableData: [],
      page: 1,
      pageSize: 10,
      pageSizeArray: [5, 10, 30, 50, 100],
      total: 0,
      typeObject: {
        1: "扣除",
        2: "增加",
        3: "冻结",
        4: "解冻",
      },
      effectiveDate: {
        disabledDate(date) {
          return date > Date.now();
        },
      },
    };
  },
  created() {
    getIntegralLogSourceApi().then((res) => {
      this.sourceList = res.data.list;
      const obj = {};
      res.data.list.map((item) => {
        obj[item.key] = item.value;
      });
      this.sourceObject = obj;
    });
    // 单次watch页面展示，然后加载数据
    const unwatch = this.$watch("visible", (n) => {
      if (n) {
        this.handleSearch();
      }
      this.$nextTick(() => {
        unwatch();
      });
    });
    if (this.visible) {
      this.handleSearch();
    }
  },
  methods: {
    handleSearch() {
      this.getList({
        page: 1,
        page_size: this.pageSize,
      });
    },
    handleReset() {
      this.searchInfo = {
        key_word: "",
        type: [],
        source: "",
        date: [],
      };
      this.handleSearch();
    },
    getList(page) {
      const params = {
        page: page.page,
        page_size: page.page_size,
      };
      if (this.searchInfo.date) {
        params.start_date = this.searchInfo.date[0];
        params.end_date = this.searchInfo.date[1];
      }
      if (this.searchInfo.key_word) {
        params.key_word = this.searchInfo.key_word;
      }
      if (this.searchInfo.source && this.searchInfo.source >= 0) {
        params.source = this.searchInfo.source;
      }
      if (this.searchInfo.type.length > 0) {
        params.type = this.searchInfo.type;
      }
      getIntegralLogListApi(params).then((res) => {
        res.data.list.map((item) => {
          item.create_time = dateFormat(
            "YYYY-mm-dd HH:MM",
            new Date(item.create_time * 1000)
          );
        });
        this.tableData = res.data.list;
        this.page = res.data.page;
        this.total = res.data.total;
      });
    },
    handlePagerChange(e) {
      this.getList({
        page: e,
        page_size: this.pageSize,
      });
    },
    handlePagerSizeChange(e) {
      this.pageSize = e;
      this.getList({
        page: 1,
        page_size: e,
      });
    },
    handleExport() {
      const params = {};
      if (this.searchInfo.date) {
        params.start_date = this.searchInfo.date[0];
        params.end_date = this.searchInfo.date[1];
      }
      if (this.searchInfo.key_word) {
        params.key_word = this.searchInfo.key_word;
      }
      if (this.searchInfo.source >= 0) {
        params.source = this.searchInfo.source;
      }
      if (this.searchInfo.type.length > 0) {
        params.type = this.searchInfo.type;
      }
      exportIntegralLogApi(params).then((res) => {
        exportLoop(res.data.task_id);
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.container {
  background-color: #ffffff;
  padding: 0 12px 12px 12px;
  border-radius: 4px;
  overflow: hidden;
}
.head-btns {
  margin-bottom: 13px;
}
</style>
